// src/app/shared/utils/global-message.util.ts
import { ConfirmationService } from 'primeng/api';

import { Observable } from 'rxjs';
import { MasterData } from '@card-software/nexus-utilities';

export class MasterDataActionUtil {
  private static confirmationService: ConfirmationService;
  private static readonly DEFAULT_KEY = 'main';

  public static init(confirmationService: ConfirmationService) {
    MasterDataActionUtil.confirmationService = confirmationService;
  }

  public static attemptToDeleteMasterData(masterData: MasterData): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      MasterDataActionUtil.confirmationService?.confirm({
        message: `Are you sure you want to delete <b>${masterData.name}</b>?`,
        header: 'Delete Confirmation',
        icon: 'pi pi-exclamation-triangle',
        key: MasterDataActionUtil.DEFAULT_KEY,
        accept: () => {
          observer.next(true);
          observer.complete();
        },
        reject: () => {
          observer.next(false);
          observer.complete();
        },
      });
    });
  }
}
